import { dividerClassName } from './styles';

const Divider = () => {
  return <div className={dividerClassName} />;
};

Divider.displayName = 'Divider';

export default Divider;
